import "../styles/Productos.css";
import sanux from "../assets/icons/SANUX.png"; // imagen de uva
import creser from "../assets/icons/CRESER.png";
import denzo from "../assets/icons/DENZO.png";
import florganix from "../assets/icons/FLORGANIX.png";
import pasomir from "../assets/icons/PASOMIR.png";
import pasorganico from "../assets/icons/PASORGÁNICO.png";
import sanux1 from "../assets/productos/Sanux.png"; // imagen de uva
import creser1 from "../assets/productos/Crecer.png";
import denzo1 from "../assets/productos/Denzo.png";
import florganix1 from "../assets/productos/Florganix.png";
import pasomir1 from "../assets/productos/Pasomir.png";
import pasorganico1 from "../assets/productos/Pasorganico.png";
import React, { useState, useEffect, useRef } from "react";

const productos = [
  {
    nombre: "SANUX",
    subtitulo: "Protección y equilibrio",
    descripcion:
      "Restaura la salud del cultivo con una combinación ideal de micronutrientes que fortalecen el sistema ante alteraciones.",
    presentacion: "1L / 4L / 20L",
    ingredientes: "Potasio, calcio, magnesio, azufre, zinc, boro, cobre",
    imagen: sanux,
    imagen1: sanux1,
  },
  {
    nombre: "FLORGANIX",
    subtitulo: "Reproducción saludable",
    descripcion:
      "Especial para etapas de floración y formación de fruto. Estimula estructuras reproductivas clave.",
    presentacion: "1L / 4L / 20L",
    ingredientes: "Potasio, fósforo, zinc, boro",
    imagen: florganix,
    imagen1: florganix1,
  },
  {
    nombre: "CRESER",
    subtitulo: "Energía para crecer",
    descripcion:
      "Activa los procesos metabólicos y amplía la capacidad fotosintética.",
    presentacion: "1L / 4L / 20L",
    ingredientes: "Nitrógeno, fósforo, potasio",
    imagen: creser,
    imagen1: creser1,
  },
  {
    nombre: "DENZO",
    subtitulo: "Engorde eficiente",
    descripcion:
      "Optimiza el llenado de frutos y granos, maximizando calidad y peso.",
    presentacion: "1L / 4L / 20L",
    ingredientes: "Manganeso, calcio, boro, potasio, zinc",
    imagen: denzo,
    imagen1: denzo1,
  },
  {
    nombre: "PASOMIR",
    subtitulo: "Desarrollo integral y sostenibilidad",
    descripcion:
      "Mejora la absorción de raíces, incrementa resistencia y fortalece el crecimiento del cultivo.",
    presentacion: "1L / 4L / 20L",
    ingredientes: "Calcio, fósforo, zinc, cobre, azufre, boro",
    imagen: pasomir,
    imagen1: pasomir1,
  },
  {
    nombre: "PASORGANICO",
    subtitulo: "Vitalidad del suelo",
    descripcion:
      "Mejora la salud física, química y biológica del suelo con fósforo, zinc, boro y carbono orgánico.",
    presentacion: "1L / 4L / 20L",
    ingredientes: "Potasio soluble, fósforo asimilable, boro, zinc, carbono orgánico.",
    imagen: pasorganico,
    imagen1: pasorganico1,
  },
];

const Productos = () => {
  const [openProduct, setOpenProduct] = useState(null);
  const closeBtnRef = useRef(null);

  // Cerrar con ESC y bloquear scroll del body
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setOpenProduct(null);
    if (openProduct) {
      document.body.style.overflow = "hidden";
      window.addEventListener("keydown", onKey);
    } else {
      document.body.style.overflow = "";
    }
    return () => window.removeEventListener("keydown", onKey);
  }, [openProduct]);

  // Enfocar botón de cierre al abrir
  useEffect(() => {
    if (openProduct && closeBtnRef.current) {
      closeBtnRef.current.focus();
    }
  }, [openProduct]);

  return (
    <section className="productos" id="productos">
      <h2 class="section-title">PRODUCTOS</h2>

      <div className="productos-grid">
        {productos.map((p, i) => (
          <article
            key={i}
            className="producto-card"
            onClick={() => setOpenProduct(p)}
            onKeyDown={(e) => (e.key === "Enter" ? setOpenProduct(p) : null)}
            tabIndex={0}
            role="button"
            aria-label={`Abrir ${p.nombre}`}
          >
            <div className="card-badge">
              {p.imagen ? (
                <img src={p.imagen} alt={p.nombre} />
              ) : (
                <div className="badge-icon" />
              )}
            </div>

            <h3 className="card-title">{p.nombre}</h3>
            <h4 className="card-sub">{p.subtitulo}</h4>
            <p className="card-desc">{p.descripcion}</p>
            <small className="card-ings">
              Ingredientes clave: {p.ingredientes}
            </small>
             <p className="card-mas">VER MÁS</p>
          </article>
        ))}
      </div>

      {/* MODAL */}
      {openProduct && (
        <div
          className="modal-backdrop"
          onClick={() => setOpenProduct(null)}
          aria-hidden
        >
          <div
            className="modal-dialog"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-title"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              ref={closeBtnRef}
              className="modal-close"
              onClick={() => setOpenProduct(null)}
              aria-label="Cerrar"
            >
              ✕
            </button>

            <div className="modal-content">
              <div className="modal-media">
                {openProduct.imagen ? (
                  <img
                    src={openProduct.imagen1}
                    alt={openProduct.nombre}
                    className="modal-img"
                  />
                ) : (
                  <div className="modal-placeholder" />
                )}
              </div>

              <div className="modal-info">
                <h3 id="modal-title">{openProduct.nombre}</h3>
                <h4>{openProduct.subtitulo}</h4>
                <p className="modal-pres">
                  Presentaciones: {openProduct.presentacion}
                </p>
                <p className="modal-desc">{openProduct.descripcion}</p>
                <p className="modal-ings">
                  <strong>Ingredientes clave:</strong> {openProduct.ingredientes}
                </p>
                <div className="modal-actions">
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Productos;
